import type { CityAgencyData } from './city-agency-pages';

export const CITY_AGENCY_PAGES_WAVE32: Record<string, CityAgencyData> = {
  'strasbourg': {
    slug: 'software-development-agency-strasbourg',
    cityName: 'Strasbourg',
    countryName: 'France',
    flag: '🇫🇷',
    timezone: 'CET (UTC+1)',
    currency: 'EUR',
    title: { en: 'Software Development Agency Strasbourg | Call IT Dev', fr: 'Agence Développement Logiciel Strasbourg | Call IT Dev' },
    description: { en: 'Top software development & BPO agency in Strasbourg. Full-stack, AI, cloud & call center services from €3/h.', fr: 'Agence de développement logiciel et BPO à Strasbourg. Full-stack, IA, cloud et centre d\'appel dès 3€/h.' },
    keywords: ['software development strasbourg', 'agence développement strasbourg', 'call center strasbourg', 'BPO strasbourg'],
    heroTitle: { en: 'Software Development Agency in Strasbourg', fr: 'Agence de Développement Logiciel à Strasbourg' },
    heroSubtitle: { en: 'European Parliament city meets nearshore tech excellence. Full-stack development & BPO from Casablanca.', fr: 'La ville du Parlement européen rencontre l\'excellence tech nearshore. Développement full-stack & BPO depuis Casablanca.' },
    whyTitle: { en: 'Why Strasbourg Companies Choose Us', fr: 'Pourquoi les entreprises de Strasbourg nous choisissent' },
    whyReasons: [
      { icon: '🇪🇺', title: 'EU Institutional Hub', description: 'Serving organizations near EU institutions with compliant tech solutions.' },
      { icon: '💰', title: '65% Cost Savings', description: 'Premium development at nearshore rates vs Strasbourg agencies.' },
      { icon: '🕐', title: 'Same Timezone CET', description: 'Real-time collaboration with zero time difference from Casablanca.' },
      { icon: '🌐', title: 'Bilingual FR/DE Teams', description: 'Native French and German-speaking developers for Alsace market.' },
    ],
    services: [
      { name: 'Custom SaaS Development', description: 'Scalable SaaS platforms for EU-based organizations.' },
      { name: 'AI & Machine Learning', description: 'Intelligent automation and predictive analytics.' },
      { name: 'Cloud & DevOps', description: 'AWS, Azure, GCP infrastructure and CI/CD pipelines.' },
      { name: 'Call Center & BPO', description: 'Multilingual customer support in French, German, English.' },
    ],
    industries: [
      { name: 'EU Institutions & NGOs', description: 'Compliance-first digital solutions for European bodies.' },
      { name: 'Pharma & Biotech', description: 'Regulated software for life sciences companies in Alsace.' },
      { name: 'FinTech', description: 'Secure financial platforms with PCI-DSS alignment.' },
      { name: 'Logistics', description: 'Supply chain optimization for Rhine corridor businesses.' },
    ],
    faqs: [
      { question: 'Do you support French and German?', answer: 'Yes, our teams are natively bilingual FR/DE with full English proficiency.' },
      { question: 'How fast can you deploy?', answer: 'MVP in 4-6 weeks, full platforms in 3-4 months.' },
    ],
    localRate: '€80-140/h',
    ourRate: '€15-35/h',
    savings: '65-75%',
  },

  'nuremberg': {
    slug: 'software-development-agency-nuremberg',
    cityName: 'Nuremberg',
    countryName: 'Germany',
    flag: '🇩🇪',
    timezone: 'CET (UTC+1)',
    currency: 'EUR',
    title: { en: 'Software Development Agency Nuremberg | Call IT Dev', de: 'Softwareentwicklung Agentur Nürnberg | Call IT Dev' },
    description: { en: 'Expert software development & BPO agency in Nuremberg. Full-stack, AI, cloud & call center from €3/h.', de: 'Softwareentwicklung und BPO Agentur in Nürnberg. Full-Stack, KI, Cloud & Callcenter ab 3€/h.' },
    keywords: ['software development nuremberg', 'softwareentwicklung nürnberg', 'call center nürnberg', 'BPO nürnberg'],
    heroTitle: { en: 'Software Development Agency in Nuremberg', de: 'Softwareentwicklung Agentur in Nürnberg' },
    heroSubtitle: { en: 'Bavaria\'s tech hub meets nearshore excellence. Premium development & BPO from Casablanca.', de: 'Bayerns Tech-Hub trifft Nearshore-Exzellenz. Premium-Entwicklung & BPO aus Casablanca.' },
    whyTitle: { en: 'Why Nuremberg Companies Choose Us', de: 'Warum Nürnberger Unternehmen uns wählen' },
    whyReasons: [
      { icon: '🏭', title: 'Industrial Heritage', description: 'Serving Nuremberg\'s strong manufacturing and industrial sector.' },
      { icon: '💰', title: '70% Cost Savings', description: 'Premium quality at a fraction of Bavarian agency rates.' },
      { icon: '🕐', title: 'Same Timezone', description: 'CET alignment for seamless daily collaboration.' },
      { icon: '🔒', title: 'GDPR-Aligned', description: 'Full European data protection compliance.' },
    ],
    services: [
      { name: 'Enterprise Software', description: 'Custom ERP and MES systems for manufacturers.' },
      { name: 'IoT Development', description: 'Connected factory and Industry 4.0 solutions.' },
      { name: 'Cloud Migration', description: 'Legacy system modernization to cloud-native architectures.' },
      { name: 'Call Center & BPO', description: 'German-speaking customer support and back-office.' },
    ],
    industries: [
      { name: 'Automotive', description: 'Digital solutions for Franconia\'s automotive suppliers.' },
      { name: 'Manufacturing', description: 'Industry 4.0 and smart factory platforms.' },
      { name: 'Insurance', description: 'InsurTech solutions for Nuremberg\'s insurance sector.' },
      { name: 'Retail & E-Commerce', description: 'Omnichannel platforms for Bavarian retailers.' },
    ],
    faqs: [
      { question: 'Do you have German-speaking teams?', answer: 'Yes, native German speakers for development and customer support.' },
      { question: 'Can you handle Industry 4.0 projects?', answer: 'Absolutely — IoT, SCADA integration, and smart manufacturing are core specialties.' },
    ],
    localRate: '€90-150/h',
    ourRate: '€15-35/h',
    savings: '70-78%',
  },

  'bratislava': {
    slug: 'software-development-agency-bratislava',
    cityName: 'Bratislava',
    countryName: 'Slovakia',
    flag: '🇸🇰',
    timezone: 'CET (UTC+1)',
    currency: 'EUR',
    title: { en: 'Software Development Agency Bratislava | Call IT Dev' },
    description: { en: 'Leading software development & BPO agency serving Bratislava. Full-stack, AI, cloud & call center from $3/h.' },
    keywords: ['software development bratislava', 'call center bratislava', 'BPO slovakia', 'IT outsourcing bratislava'],
    heroTitle: { en: 'Software Development Agency in Bratislava', fr: 'Agence de Développement Logiciel à Bratislava' },
    heroSubtitle: { en: 'Central European innovation hub meets Moroccan nearshore expertise. Enterprise development & BPO.', fr: 'Le hub d\'innovation d\'Europe centrale rencontre l\'expertise nearshore marocaine.' },
    whyTitle: { en: 'Why Bratislava Companies Choose Us' },
    whyReasons: [
      { icon: '🏛️', title: 'Capital City Hub', description: 'Serving Slovakia\'s growing startup and enterprise ecosystem.' },
      { icon: '💰', title: '55% Cost Savings', description: 'Competitive rates even vs Bratislava\'s already favorable pricing.' },
      { icon: '🕐', title: 'Same Timezone CET', description: 'Zero time difference for real-time collaboration.' },
      { icon: '🇪🇺', title: 'EU Eurozone', description: 'Seamless euro-denominated billing and GDPR compliance.' },
    ],
    services: [
      { name: 'FinTech Development', description: 'Banking and payment platforms for Slovakia\'s financial sector.' },
      { name: 'Mobile Apps', description: 'iOS and Android development with cross-platform frameworks.' },
      { name: 'Cybersecurity', description: 'Penetration testing and security audits.' },
      { name: 'Call Center & BPO', description: 'Multilingual support covering Slovak, Czech, German, English.' },
    ],
    industries: [
      { name: 'Automotive', description: 'Solutions for Slovakia\'s major automotive manufacturing sector.' },
      { name: 'Banking & Finance', description: 'Digital banking platforms and payment solutions.' },
      { name: 'Telecom', description: 'Network management and customer service platforms.' },
      { name: 'Energy', description: 'Smart grid and utility management systems.' },
    ],
    faqs: [
      { question: 'Do you serve companies in the Visegrad region?', answer: 'Yes, we serve Slovakia, Czech Republic, Hungary, and Poland with localized teams.' },
      { question: 'What languages do you support?', answer: 'Slovak, Czech, German, English, French, and more across 35+ languages.' },
    ],
    localRate: '€40-80/h',
    ourRate: '€15-35/h',
    savings: '50-60%',
  },

  'helsinki': {
    slug: 'software-development-agency-helsinki',
    cityName: 'Helsinki',
    countryName: 'Finland',
    flag: '🇫🇮',
    timezone: 'EET (UTC+2)',
    currency: 'EUR',
    title: { en: 'Software Development Agency Helsinki | Call IT Dev', sv: 'Mjukvaruutveckling Helsingfors | Call IT Dev' },
    description: { en: 'Top software development & BPO agency serving Helsinki. Full-stack, AI, gaming, cloud & call center from €3/h.' },
    keywords: ['software development helsinki', 'call center helsinki', 'BPO finland', 'IT outsourcing helsinki'],
    heroTitle: { en: 'Software Development Agency in Helsinki', fr: 'Agence de Développement Logiciel à Helsinki' },
    heroSubtitle: { en: 'Nordic innovation capital meets nearshore cost efficiency. Enterprise development, AI & BPO from Casablanca.' },
    whyTitle: { en: 'Why Helsinki Companies Choose Us' },
    whyReasons: [
      { icon: '🎮', title: 'Gaming Expertise', description: 'Supporting Finland\'s world-class gaming industry with tech talent.' },
      { icon: '💰', title: '70% Cost Savings', description: 'Premium development at a fraction of Helsinki agency rates.' },
      { icon: '🕐', title: '1h Time Difference', description: 'Near-synchronous collaboration CET to EET.' },
      { icon: '🔒', title: 'EU Compliant', description: 'Full GDPR alignment for Nordic data standards.' },
    ],
    services: [
      { name: 'AI & ML Development', description: 'Advanced AI solutions for Helsinki\'s tech ecosystem.' },
      { name: 'SaaS Platforms', description: 'Scalable cloud-native products for Nordic markets.' },
      { name: 'Mobile & Gaming', description: 'Cross-platform mobile apps and gaming backends.' },
      { name: 'Call Center & BPO', description: 'Multilingual customer support for Nordic customers.' },
    ],
    industries: [
      { name: 'Gaming & Entertainment', description: 'Backend and platform development for gaming studios.' },
      { name: 'Cleantech', description: 'Software for renewable energy and sustainability startups.' },
      { name: 'HealthTech', description: 'Digital health platforms with Nordic compliance.' },
      { name: 'SaaS & Startups', description: 'Rapid MVP development for Helsinki\'s startup scene.' },
    ],
    faqs: [
      { question: 'Can you support Finnish-language customers?', answer: 'We provide English, Swedish, and can onboard Finnish-speaking agents on demand.' },
      { question: 'Do you work with gaming companies?', answer: 'Yes, we have experience with mobile gaming backends, analytics, and player support.' },
    ],
    localRate: '€100-160/h',
    ourRate: '€15-35/h',
    savings: '70-80%',
  },

  'reykjavik': {
    slug: 'software-development-agency-reykjavik',
    cityName: 'Reykjavik',
    countryName: 'Iceland',
    flag: '🇮🇸',
    timezone: 'GMT (UTC+0)',
    currency: 'ISK',
    title: { en: 'Software Development Agency Reykjavik | Call IT Dev' },
    description: { en: 'Expert software development & BPO for Reykjavik businesses. Full-stack, AI, cloud & call center from $3/h.' },
    keywords: ['software development reykjavik', 'call center iceland', 'BPO iceland', 'IT outsourcing reykjavik'],
    heroTitle: { en: 'Software Development Agency in Reykjavik' },
    heroSubtitle: { en: 'Iceland\'s innovation spirit meets nearshore scalability. Premium tech & BPO at 70% cost savings.' },
    whyTitle: { en: 'Why Reykjavik Companies Choose Us' },
    whyReasons: [
      { icon: '🌋', title: 'Nordic Innovation', description: 'Empowering Iceland\'s tech-forward businesses with scalable solutions.' },
      { icon: '💰', title: '70% Cost Savings', description: 'Dramatic savings vs Iceland\'s high local development costs.' },
      { icon: '🕐', title: 'GMT Aligned', description: 'Same timezone as Morocco for real-time collaboration.' },
      { icon: '🌿', title: 'Green Tech', description: 'Supporting Iceland\'s sustainability-first tech ecosystem.' },
    ],
    services: [
      { name: 'SaaS Development', description: 'Cloud-native platforms for Nordic and global markets.' },
      { name: 'Data Engineering', description: 'Big data pipelines for geothermal and energy analytics.' },
      { name: 'E-Commerce', description: 'Omnichannel retail platforms for Icelandic brands.' },
      { name: 'Call Center & BPO', description: 'English and Nordic language customer support.' },
    ],
    industries: [
      { name: 'Energy & Geothermal', description: 'Software for Iceland\'s renewable energy sector.' },
      { name: 'Tourism & Travel', description: 'Booking and experience platforms for tourism businesses.' },
      { name: 'Fisheries & Maritime', description: 'Fleet management and logistics systems.' },
      { name: 'FinTech', description: 'Payment and banking solutions for the Icelandic market.' },
    ],
    faqs: [
      { question: 'Can you work in GMT timezone?', answer: 'Yes, Morocco is GMT-aligned making us ideal for Icelandic businesses.' },
      { question: 'Do you handle small projects?', answer: 'Absolutely — from MVPs to enterprise platforms, we scale to your needs.' },
    ],
    localRate: '€120-180/h',
    ourRate: '€15-35/h',
    savings: '75-82%',
  },

  'ahmedabad': {
    slug: 'software-development-agency-ahmedabad',
    cityName: 'Ahmedabad',
    countryName: 'India',
    flag: '🇮🇳',
    timezone: 'IST (UTC+5:30)',
    currency: 'INR',
    title: { en: 'Software Development Agency Ahmedabad | Call IT Dev' },
    description: { en: 'Leading software development & BPO agency serving Ahmedabad. Full-stack, AI, cloud & call center from $3/h.' },
    keywords: ['software development ahmedabad', 'call center ahmedabad', 'BPO ahmedabad', 'IT outsourcing ahmedabad'],
    heroTitle: { en: 'Software Development Agency in Ahmedabad' },
    heroSubtitle: { en: 'Gujarat\'s commercial capital meets global nearshore expertise. Enterprise development & BPO.' },
    whyTitle: { en: 'Why Ahmedabad Companies Choose Us' },
    whyReasons: [
      { icon: '🏭', title: 'Industrial Capital', description: 'Serving Gujarat\'s massive manufacturing and textile ecosystem.' },
      { icon: '💰', title: 'Competitive Pricing', description: 'Premium quality with transparent nearshore pricing.' },
      { icon: '🌐', title: 'Multilingual Teams', description: 'English, Hindi, Gujarati-aware support capabilities.' },
      { icon: '⚡', title: 'Rapid Delivery', description: 'Agile teams delivering MVPs in 4-6 weeks.' },
    ],
    services: [
      { name: 'ERP & CRM Systems', description: 'Custom enterprise resource planning for manufacturers.' },
      { name: 'E-Commerce Platforms', description: 'Scalable online retail solutions for Gujarat businesses.' },
      { name: 'Mobile Apps', description: 'Cross-platform mobile applications for B2B and B2C.' },
      { name: 'Call Center & BPO', description: 'Customer support and back-office processing.' },
    ],
    industries: [
      { name: 'Textiles & Manufacturing', description: 'Digital transformation for Gujarat\'s textile industry.' },
      { name: 'Pharma', description: 'Regulatory-compliant software for pharmaceutical companies.' },
      { name: 'Real Estate', description: 'PropTech solutions for Ahmedabad\'s booming real estate.' },
      { name: 'Education', description: 'EdTech platforms for Gujarat\'s education sector.' },
    ],
    faqs: [
      { question: 'Do you serve Indian domestic clients?', answer: 'Yes, we serve both Indian and international clients with competitive pricing.' },
      { question: 'What tech stack do you use?', answer: 'React, Node.js, Python, Java, .NET, Flutter, and more.' },
    ],
    localRate: '$20-50/h',
    ourRate: '$8-20/h',
    savings: '50-65%',
  },

  'daegu': {
    slug: 'software-development-agency-daegu',
    cityName: 'Daegu',
    countryName: 'South Korea',
    flag: '🇰🇷',
    timezone: 'KST (UTC+9)',
    currency: 'KRW',
    title: { en: 'Software Development Agency Daegu | Call IT Dev', ko: '대구 소프트웨어 개발 에이전시 | Call IT Dev' },
    description: { en: 'Expert software development & BPO agency serving Daegu. Full-stack, AI, cloud & call center from $3/h.' },
    keywords: ['software development daegu', 'call center daegu', 'BPO south korea', '대구 소프트웨어 개발'],
    heroTitle: { en: 'Software Development Agency in Daegu', ko: '대구 소프트웨어 개발 에이전시' },
    heroSubtitle: { en: 'South Korea\'s textile and tech city meets global nearshore expertise. Full-stack & BPO solutions.' },
    whyTitle: { en: 'Why Daegu Companies Choose Us' },
    whyReasons: [
      { icon: '🏙️', title: 'Regional Tech Hub', description: 'Serving Daegu\'s growing tech and innovation ecosystem.' },
      { icon: '💰', title: '60% Cost Savings', description: 'Premium development at significantly lower rates than Korean agencies.' },
      { icon: '🎯', title: 'Quality Focus', description: 'ISO-aligned processes meeting Korean quality standards.' },
      { icon: '🌐', title: 'Korean Support', description: 'Korean-language coordination for seamless collaboration.' },
    ],
    services: [
      { name: 'AI Development', description: 'Machine learning and deep learning solutions.' },
      { name: 'Mobile Apps', description: 'iOS and Android apps optimized for Korean market.' },
      { name: 'Cloud Infrastructure', description: 'AWS and cloud-native architecture design.' },
      { name: 'Call Center & BPO', description: 'Multilingual support including Korean coordination.' },
    ],
    industries: [
      { name: 'Textiles & Fashion', description: 'E-commerce and supply chain software for Daegu\'s textile industry.' },
      { name: 'Healthcare', description: 'MedTech platforms for hospitals and clinics.' },
      { name: 'Automotive Parts', description: 'Digital supply chain for auto parts manufacturers.' },
      { name: 'Education', description: 'EdTech solutions for Korean educational institutions.' },
    ],
    faqs: [
      { question: 'Can you work with Korean business hours?', answer: 'We offer flexible scheduling with overlapping hours for Korean clients.' },
      { question: 'Do you understand Korean business culture?', answer: 'Yes, our project managers are trained in Korean business practices and communication styles.' },
    ],
    localRate: '$60-120/h',
    ourRate: '$8-25/h',
    savings: '60-75%',
  },

  'kumasi': {
    slug: 'software-development-agency-kumasi',
    cityName: 'Kumasi',
    countryName: 'Ghana',
    flag: '🇬🇭',
    timezone: 'GMT (UTC+0)',
    currency: 'GHS',
    title: { en: 'Software Development Agency Kumasi | Call IT Dev' },
    description: { en: 'Leading software development & BPO agency in Kumasi, Ghana. Full-stack, AI, mobile & call center from $3/h.' },
    keywords: ['software development kumasi', 'call center kumasi', 'BPO ghana', 'IT outsourcing kumasi'],
    heroTitle: { en: 'Software Development Agency in Kumasi' },
    heroSubtitle: { en: 'Ghana\'s Garden City and tech hub meets nearshore excellence. Enterprise development & BPO.' },
    whyTitle: { en: 'Why Kumasi Companies Choose Us' },
    whyReasons: [
      { icon: '🌍', title: 'West African Hub', description: 'Serving Ghana\'s second-largest city and Ashanti region.' },
      { icon: '💰', title: 'Affordable Excellence', description: 'High-quality development at competitive African rates.' },
      { icon: '🕐', title: 'GMT Timezone', description: 'Perfect alignment with Morocco and UK working hours.' },
      { icon: '🗣️', title: 'English Native', description: 'Anglophone teams for seamless communication.' },
    ],
    services: [
      { name: 'Mobile-First Development', description: 'Apps optimized for African mobile-first markets.' },
      { name: 'FinTech & Mobile Money', description: 'Payment platforms and mobile banking solutions.' },
      { name: 'E-Commerce', description: 'Online marketplaces for West African businesses.' },
      { name: 'Call Center & BPO', description: 'English-speaking customer support for Ghana and beyond.' },
    ],
    industries: [
      { name: 'Agriculture', description: 'AgriTech solutions for cocoa and farming sectors.' },
      { name: 'Mining', description: 'Digital management systems for Ashanti gold mining.' },
      { name: 'Education', description: 'EdTech platforms for Ghanaian schools and universities.' },
      { name: 'Healthcare', description: 'Telemedicine and hospital management systems.' },
    ],
    faqs: [
      { question: 'Do you serve both local and international Kumasi clients?', answer: 'Yes, we work with Ghanaian businesses and international companies expanding into West Africa.' },
      { question: 'What mobile platforms do you support?', answer: 'Android, iOS, Flutter, React Native, and USSD for feature phones.' },
    ],
    localRate: '$15-40/h',
    ourRate: '$8-20/h',
    savings: '40-55%',
  },

  'kuwait-city': {
    slug: 'software-development-agency-kuwait-city',
    cityName: 'Kuwait City',
    countryName: 'Kuwait',
    flag: '🇰🇼',
    timezone: 'AST (UTC+3)',
    currency: 'KWD',
    title: { en: 'Software Development Agency Kuwait City | Call IT Dev', ar: 'وكالة تطوير برمجيات مدينة الكويت | Call IT Dev' },
    description: { en: 'Top software development & BPO agency in Kuwait City. Full-stack, AI, cloud & call center from $3/h.', ar: 'أفضل وكالة تطوير برمجيات وخدمات BPO في مدينة الكويت. تطوير شامل، ذكاء اصطناعي وخدمات مركز اتصال.' },
    keywords: ['software development kuwait', 'call center kuwait', 'BPO kuwait', 'تطوير برمجيات الكويت'],
    heroTitle: { en: 'Software Development Agency in Kuwait City', ar: 'وكالة تطوير برمجيات في مدينة الكويت' },
    heroSubtitle: { en: 'Gulf innovation hub meets nearshore expertise. Enterprise development, AI & multilingual BPO.', ar: 'مركز الابتكار الخليجي يلتقي بالخبرة التقنية. تطوير المؤسسات والذكاء الاصطناعي.' },
    whyTitle: { en: 'Why Kuwait City Companies Choose Us', ar: 'لماذا تختارنا شركات مدينة الكويت' },
    whyReasons: [
      { icon: '🛢️', title: 'Oil & Gas Expertise', description: 'Digital transformation for Kuwait\'s energy sector.' },
      { icon: '💰', title: '65% Cost Savings', description: 'Premium development at nearshore rates vs Kuwait agencies.' },
      { icon: '🗣️', title: 'Arabic Native', description: 'Native Arabic-speaking teams for perfect cultural fit.' },
      { icon: '🔒', title: 'Compliant', description: 'GDPR-aligned and GCC data protection standards.' },
    ],
    services: [
      { name: 'Enterprise Portals', description: 'Government and corporate portal development.' },
      { name: 'AI & Analytics', description: 'Business intelligence and predictive analytics for energy sector.' },
      { name: 'Mobile Apps', description: 'Arabic-first mobile applications for Kuwaiti market.' },
      { name: 'Call Center & BPO', description: 'Arabic and English customer support 24/7.' },
    ],
    industries: [
      { name: 'Oil & Gas', description: 'Digital platforms for Kuwait\'s petroleum industry.' },
      { name: 'Banking & Finance', description: 'Islamic banking and FinTech solutions.' },
      { name: 'Government', description: 'E-government portals and smart city solutions.' },
      { name: 'Real Estate', description: 'PropTech for Kuwait\'s development sector.' },
    ],
    faqs: [
      { question: 'Do you support Arabic RTL interfaces?', answer: 'Yes, all our applications support full Arabic RTL with culturally adapted UX.' },
      { question: 'Can you work with Kuwait government projects?', answer: 'Yes, we have experience with GCC government digital transformation initiatives.' },
    ],
    localRate: '$80-150/h',
    ourRate: '$15-35/h',
    savings: '65-78%',
  },

  'san-jose-costa-rica': {
    slug: 'software-development-agency-san-jose-costa-rica',
    cityName: 'San José',
    countryName: 'Costa Rica',
    flag: '🇨🇷',
    timezone: 'CST (UTC-6)',
    currency: 'CRC',
    title: { en: 'Software Development Agency San José | Call IT Dev', es: 'Agencia Desarrollo Software San José Costa Rica | Call IT Dev' },
    description: { en: 'Leading software development & BPO agency in San José, Costa Rica. Full-stack, AI, cloud & call center from $3/h.', es: 'Agencia de desarrollo de software y BPO en San José, Costa Rica. Full-stack, IA, cloud y centro de llamadas.' },
    keywords: ['software development san jose costa rica', 'call center costa rica', 'BPO costa rica', 'desarrollo software san jose'],
    heroTitle: { en: 'Software Development Agency in San José, Costa Rica', es: 'Agencia de Desarrollo de Software en San José, Costa Rica' },
    heroSubtitle: { en: 'Central America\'s tech capital meets global nearshore expertise. Full-stack development & BPO.', es: 'La capital tecnológica de Centroamérica se une a la experiencia nearshore global.' },
    whyTitle: { en: 'Why San José Companies Choose Us', es: 'Por qué las empresas de San José nos eligen' },
    whyReasons: [
      { icon: '🌴', title: 'Tech Capital LATAM', description: 'Serving Costa Rica\'s established nearshore and tech ecosystem.' },
      { icon: '💰', title: '50% Cost Savings', description: 'Even more competitive than Costa Rica\'s already favorable rates.' },
      { icon: '🗣️', title: 'Spanish & English', description: 'Fully bilingual teams for LATAM and US markets.' },
      { icon: '🌿', title: 'Pura Vida Quality', description: 'Premium development matching Costa Rica\'s reputation for quality.' },
    ],
    services: [
      { name: 'SaaS Development', description: 'Cloud-native SaaS platforms for LATAM markets.' },
      { name: 'Staff Augmentation', description: 'Dedicated developers to extend your Costa Rican team.' },
      { name: 'QA & Testing', description: 'Comprehensive testing and quality assurance services.' },
      { name: 'Call Center & BPO', description: 'Spanish and English support for Americas timezone.' },
    ],
    industries: [
      { name: 'Tourism & Hospitality', description: 'Booking and experience platforms for eco-tourism.' },
      { name: 'Medical Devices', description: 'Regulated software for Costa Rica\'s med-tech zone.' },
      { name: 'FinTech', description: 'Digital payment solutions for Central American markets.' },
      { name: 'Shared Services', description: 'BPO solutions for multinational shared services centers.' },
    ],
    faqs: [
      { question: 'How do you compare to Costa Rican agencies?', answer: 'We offer 40-50% savings with the same quality standards and bilingual capabilities.' },
      { question: 'Can you cover Americas timezone?', answer: 'Yes, we operate flexible shifts covering UTC-8 to UTC-3.' },
    ],
    localRate: '$35-70/h',
    ourRate: '$8-25/h',
    savings: '50-65%',
  },
};
